import {Injectable, NgZone} from '@angular/core';
import {DeviceDetectorService} from 'ngx-device-detector';
import {BehaviorSubject, Subject} from 'rxjs';
import {AlertService} from './alert.service';

@Injectable({
  providedIn: 'root',
})
export class UIService {

  private deviceScreen;

  constructor(private deviceService: DeviceDetectorService,
              public alertService: AlertService) {
    this.screen.width = window.innerWidth;
    this.screen.height = window.innerHeight;
    this.browser = deviceService.browser;
    this.deviceScreen = {width: window.screen.width, height: window.screen.height};
    if (this.isFirefox()) {
      this.actualDevicePixelRatio = window.devicePixelRatio / 0.6976744186046512;
    } else {
      this.actualDevicePixelRatio = window.devicePixelRatio;
    }
  }

  public loadingSubject = new BehaviorSubject<boolean>(false);

  screen: { width: number, height: number } = {width: 0, height: 0};
  browser: string;
  public actualDevicePixelRatio = 1;


  isFirefox(): boolean {
    return this.browser && this.browser.includes('Firefox');
  }
}
